import { AnnouncementsValues } from '@/components/forms/form-announcements/FormAnnouncements';
import useGetAnnouncementById from '@/hooks/queries/announcements-api/useGetAnnouncementById';
import usePatchAnnouncements from '@/hooks/queries/announcements-api/usePatchAnnouncements';
import useGetOrganizationFromCache from '@/hooks/queries/organization-api/useGetOrganizationFromCache';
import { getTimestampUTC } from '@/utils/dates';
import { getChangedValues } from '@/utils/forms';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';

const useEditAnnouncements = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { data: announcement, isError, isLoading } = useGetAnnouncementById(id);
  const { mutate, isPending } = usePatchAnnouncements();
  const organization = useGetOrganizationFromCache();

  const defaultValues = {
    title: announcement?.title,
    description: announcement?.description,
    startTime: new Date(announcement?.startTime),
    endTime: new Date(announcement?.endTime),
    audience: announcement?.audience
  };

  const onSubmit = (data: AnnouncementsValues) => {
    type partialType = Omit<AnnouncementsValues, 'startTime' | 'endTime'> & {
      startTime: number;
      endTime: number;
    };
    const onlyChangedData = getChangedValues<Partial<partialType>>(
      {
        ...defaultValues,
        startTime: announcement.startTime,
        endTime: announcement.endTime
      },
      {
        ...data,
        startTime: getTimestampUTC({
          date: data.startTime,
          time: '00:00:00',
          tz: organization?.tz ?? 'America/Argentina/Buenos_Aires'
        }),
        endTime: getTimestampUTC({
          date: data.endTime,
          time: '23:59:59',
          tz: organization?.tz ?? 'America/Argentina/Buenos_Aires'
        })
      }
    );
    if (Object.keys(onlyChangedData).length > 0) {
      mutate({
        payload: onlyChangedData,
        announcementId: announcement.id
      });
    } else toast.error(t('toast.noChanges'));
  };

  return {
    isLoading,
    isError,
    announcement,
    onSubmit,
    defaultValues,
    isPending
  };
};

export default useEditAnnouncements;
